import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { flexCenter } from '@seedlang/style_mixins';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Description from 'components/exercise/description';
import TextDisplay from 'components/text_display';

const Wrapper = styled.div`
  margin-bottom: 10px;
  img {
    max-width: 100%;
    max-height: 500px;
  }
`;

const Button = styled.div`
  ${flexCenter()}
  background: rgb(134, 134, 134);
  font-weight: bold;
  height: 40px;
  color: white;
  font-size: 14px;
  border-radius: 10px;
  margin-top: 10px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  padding: 5px;
`;

@observer
class ExpandableDescription extends React.Component {
  @observable selectedExpanded = false;

  componentDidUpdate(prevProps) {
    if (this.props.exerciseId !== prevProps.exerciseId) {
      this.selectedExpanded = false;
    }
  }

  render() {
    return (
      <Wrapper>
        <Description
          padding={this.selectedExpanded ? '10px 10px 0 10px' : '10px'}
          borderRadius={this.selectedExpanded ? '10px 10px 0 0' : '10px'}
        >
          <TextDisplay
            scrollable
            htmlText={this.props.defaultDescription}
          />
        </Description>
        {
          this.props.expandedDescription && !this.selectedExpanded &&
            <Button
              onClick={() => !this.props.blockExpansion ? this.selectedExpanded = true : null}
              disabled={this.props.blockExpansion}
            >
              <i className='fa fa-plus' style={{marginRight: '5px'}}/>
              READ MORE
            </Button>
        }
        {
          this.selectedExpanded &&
            <Description
              padding='20px 10px 10px 10px'
              borderRadius='0 0 10px 10px '
            >
              <TextDisplay scrollable htmlText={this.props.expandedDescription} />
            </Description>
        }
        {
          this.props.expandedDescription && this.selectedExpanded && !this.props.hideCollapseButton &&
          <Button
            onClick={() => this.selectedExpanded = false}
          >
            <i className='fa fa-minus' style={{marginRight: '5px'}} />
            COLLAPSE
          </Button>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ExpandableDescription);
